import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaUser, FaPaperPlane, FaCommentDots } from 'react-icons/fa';

const ContactUs = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message submitted. We will contact you shortly.');
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-cyan-50 py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header section */}
          <div className="bg-gradient-to-r from-green-600 to-emerald-700 p-8 text-white">
            <h1 className="text-4xl font-bold mb-3">Contact Us</h1>
            <p className="text-green-100 text-xl">Have a question or feedback? Fill the form and we'll get back to you.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 p-8">
            <div className="space-y-6">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-gray-700 font-medium mb-2 flex items-center gap-2">
                    <FaUser className="text-green-600" /> Name
                  </label>
                  <input 
                    name="name" 
                    value={form.name} 
                    onChange={handleChange} 
                    required 
                    className="w-full border border-gray-300 rounded-xl p-4 focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all" 
                    placeholder="Enter your name"
                  />
                </div>
                
                <div>
                  <label className="block text-gray-700 font-medium mb-2 flex items-center gap-2">
                    <FaEnvelope className="text-green-600" /> Email
                  </label>
                  <input 
                    name="email" 
                    value={form.email} 
                    onChange={handleChange} 
                    type="email" 
                    required 
                    className="w-full border border-gray-300 rounded-xl p-4 focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all" 
                    placeholder="Enter your email address"
                  />
                </div>
                
                <div className="lg:col-span-2">
                  <label className="block text-gray-700 font-medium mb-2 flex items-center gap-2">
                    <FaCommentDots className="text-green-600" /> Message
                  </label>
                  <textarea 
                    name="message" 
                    value={form.message} 
                    onChange={handleChange} 
                    required 
                    className="w-full border border-gray-300 rounded-xl p-4 h-40 focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all resize-none" 
                    placeholder="Type your message here..."
                  />
                </div>
                
                <div>
                  <button 
                    type="submit" 
                    className="w-full bg-gradient-to-r from-green-600 to-emerald-700 hover:from-green-700 hover:to-emerald-800 text-white font-bold py-4 px-6 rounded-xl flex items-center justify-center gap-2 transition-all transform hover:scale-[1.02] shadow-lg"
                  >
                    <FaPaperPlane /> Send Message
                  </button>
                </div>
              </form>
            </div>

            <div className="space-y-6">
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border border-green-100">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">Contact Information</h3>
                
                <div className="space-y-5">
                  <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm">
                    <div className="bg-green-100 p-3 rounded-lg text-green-700">
                      <FaEnvelope size={20} />
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800">Customer Care</h4>
                      <p className="text-gray-600">info@kisanfresh.com</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm">
                    <div className="bg-green-100 p-3 rounded-lg text-green-700">
                      <FaPhone size={20} />
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800">Call Us</h4>
                      <p className="text-gray-600">+91 9356700237</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm">
                    <div className="bg-green-100 p-3 rounded-lg text-green-700">
                      <FaMapMarkerAlt size={20} />
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800">Visit Us</h4>
                      <p className="text-gray-600">Pune, Maharashtra, India</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-emerald-600 to-green-700 rounded-2xl p-6 text-white">
                <h3 className="text-xl font-bold mb-3">Business Hours</h3>
                <p className="mb-2">Monday - Friday: 9AM - 8PM</p>
                <p>Saturday: 10AM - 6PM</p>
                <p className="mt-3 text-emerald-100 italic">We respond to all inquiries within 24 hours</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;